import React from "react";
import PropTypes from "prop-types";
import { Backdrop, CircularProgress } from "@mui/material";
import { observer } from "mobx-react-lite";

const preloader = (props: any) => {
  return (
    <Backdrop sx={{ color: "#fff" }} open={true}>
        Loading... Please Wait
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

preloader.propTypes = {};

export default observer(preloader);
